const ambitiAmbiente = (ambiti) => {
  const mappedArray = ambiti.filter(ambito => (ambito.classe=='AMB' && ambito.enabled)).map(elem => {
    return {
      "name": elem.key + " - " + elem.descrizione,
      "to": "/app/questionario/compila-ambito/" + elem.key,
      "exact": true,
      "active": true,
      "icon": "pencil-alt"
    }
  })
  return mappedArray
}

const ambitiGovernance = (ambiti) => {
  const mappedArray = ambiti.filter(ambito => (ambito.classe=='GOV' && ambito.enabled)).map(elem => {
    return {
      "name": elem.key + " - " + elem.descrizione,
      "to": "/app/questionario/compila-ambito/" + elem.key,
      "exact": true,
      "active": true,
      "icon": "pencil-alt"
    }
  })
  return mappedArray
}

const ambitiSociale = (ambiti) => {
  const mappedArray = ambiti.filter(ambito => (ambito.classe=='SOC' && ambito.enabled)).map(elem => {
    return {
      "name": elem.key + " - " + elem.descrizione,
      "to": "/app/questionario/compila-ambito/" + elem.key,
      "exact": true,
      "active": true,
      "icon": "pencil-alt"
    }
  })
  return mappedArray
}


export const funzioneSelezionaAmbiti = (ambiti) =>{
  if (typeof ambiti === "undefined") {
     return {
      "label": "INPUT -> Compilazione valutazione rilevanza rischi e azioni di mitigazione",
      "children": []
    }
  } else if (ambiti === null) {
    //console.log('*** funzioneSelezionaAmbiti --- ambiti is null')
    return {
      "label": "INPUT -> Compilazione valutazione rilevanza rischi e azioni di mitigazione",
      "children": []
    }
  } else {
    return {
      "label": "INPUT -> Compilazione valutazione rilevanza rischi e azioni di mitigazione",
      "children": [
        {
          "name": "Ambiti \"Ambiente\"",
          "exact": true,
          "active": true,
          "children": ambitiAmbiente (ambiti)
        },
        {
          "name": "Ambiti \"Governance\"",
          "exact": true,
          "active": true,
          "children": ambitiGovernance (ambiti)
        },
        {
          "name": "Ambiti \"Sociale\"",
          "exact": true,
          "active": true,
          "children": ambitiSociale (ambiti)
        }
      ]
    }
  }
}
